import { render } from "./Consulting.vue?vue&type=template&id=03cee555&bindings={}"
import script from "./Consulting.vue?vue&type=script&lang=ts"
export * from "./Consulting.vue?vue&type=script&lang=ts"
script.render = render

export default script